module.exports = __webpack_public_path__ + "static/img/LBT.be7cd52.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/leven/LBT.jpg
// module id = 8dom
// module chunks = 1